import { useEffect as reactUseEffect, useLayoutEffect as reactUseLayoutEffect } from 'react'

export const useLayoutEffect = typeof window !== 'undefined' ? reactUseLayoutEffect : reactUseEffect
